// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2512":"f2da2b5a0883b518","8198":"fe66ba4c646dad2b","8730":"d283b895985ff5b7"}[chunkId] + ".css";
};